import React, { useEffect } from 'react';
import '../Styles/Opportunities.css';
import AppHeader from '../Layout/Header';
import FooterComponent from '../Layout/Footer';
import CollaborateWithUs from '../Components/OppurtunitiesComponents/Collabore';
import { Link } from 'react-router-dom';
import FooterQuote from '../Layout/FooterQuote';
import internshipPoster from '../Assets/Internships/internship-2026.jpg';

const Opportunities = () => {
    useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);
  return (
   <>
   <AppHeader/>
  <div style={{marginTop:"20px",marginBottom:"20px"
  }}>
  <div className="opportunities-container">
      <div className="opportunities-overlay" aria-hidden="true" />
    </div>
    <main className="page-content-bands">
      <section className="opportunities-intro" aria-labelledby="opportunities-intro-title">
        <div className="opportunities-section-inner">
          <p className="section-eyebrow">EXPLORE · CONTRIBUTE · GROW</p>
          <h1 id="opportunities-intro-title">Build Your Future With NCGSA</h1>
          <div className="opportunities-title-line" aria-hidden="true" />
          <p>
            At NCGSA, we offer internships and provide collaborative opportunities that enable
            individuals to explore new ventures and contribute actively to the field of space
            science and technology. Our programs offer hands-on experience, guidance from
            experienced researchers, and the chance to work on impactful projects that advance
            space research and applications.
          </p>
        </div>
      </section>

      <section className="opportunities-internship" id="internships" aria-labelledby="internship-program-title">
        <div className="opportunities-internship-inner">
          <figure>
            <img
              src={internshipPoster}
              alt="Students participating in the NCGSA internship program"
            />
          </figure>
          <div className="opportunities-internship-copy">
            <p className="section-eyebrow">HANDS-ON SPACE LEARNING</p>
            <h2 id="internship-program-title">Internship Program</h2>
            <div className="opportunities-title-line" aria-hidden="true" />
            <p>
              The NCGSA Summer Internship Program at the Institute of Space Technology (IST),
              Islamabad is an annual, hands-on learning initiative designed for students passionate
              about space science and technology. Each year, the program welcomes over 70 interns
              from diverse academic backgrounds, providing immersive exposure to cutting-edge
              domains of space research, satellite technology, and aerospace applications.
            </p>
            <p>
              Through practical workshops, expert-led sessions, and collaborative projects,
              participants acquire essential skills, gain real-world experience, and develop a
              deeper understanding of the space sector. The program nurtures technical competence,
              innovation, critical thinking, and teamwork.
            </p>
            <Link className="opportunities-read-more" to="/internships">Read More <span>→</span></Link>
          </div>
        </div>
      </section>
      <section id="collaborate-with-us"><CollaborateWithUs/></section>
    </main>
  </div>
    <FooterQuote
      variant="opportunities"
      quote="Mystery creates wonder, and wonder is the basis of humanity’s desire to understand."
      attribution="— Neil Armstrong"
    />
    <FooterComponent/>

   </>
  );
};

export default Opportunities;
